import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

import ToggleButtonGroup from 'components/ToggleButtonGroup'

import Chart from 'pages/Dashboard/CustomerAdoptionCard/Chart'
import Legend from 'pages/Dashboard/CustomerAdoptionCard/Legend'
import Card from 'components/Card'

import useCustomerAdoption from 'hooks/useCustomerAdoption'

import GA4 from 'helpers/ga4'
import Apptentive from 'helpers/apptentive'

const TimeSpans = [
  { key: 30, displayValue: 'PAST 30 DAYS' },
  { key: 90, displayValue: 'PAST 90 DAYS' },
  { key: 365, displayValue: 'PAST 365 DAYS' }
]

type Props = {
  className?: string
}

const CustomerAdoptionCard = ({ className = '' }: Props) => {
  const { customers, areCustomersLoaded } = useCustomerAdoption()
  const [selectedTimeSpan, setSelectedTimeSpan] = useState(TimeSpans[0].key)
  const [newCustomersAdoptionsLegendNames, setNewCustomersAdoptionsLegendNames] = useState([])
  const [existingCustomersAdoptionsLegendNames, setExistingCustomersAdoptionsLegendNames] = useState([])

  const onChangeSelectedTimeSpan = (timeSpan) => {
    setSelectedTimeSpan(timeSpan)

    GA4.sendEvent({ category: 'Dashboard Page', action: `click ${timeSpan}` })
    Apptentive.sendEvent(`view_adoption_${timeSpan}_days`)
  }

  const onNewCustomersAdoptionsChartLoaded = useCallback((labels) => {
    setNewCustomersAdoptionsLegendNames(labels)
  }, [])

  const onExistingCustomersAdoptionsChartLoaded = useCallback((labels) => {
    setExistingCustomersAdoptionsLegendNames(labels)
  }, [])

  return (
    <Card title="Customer Adoption" {...{ className }} isLoaded={areCustomersLoaded}>
      {customers && (
        <S.Container>
          <ToggleButtonGroup selectedValue={selectedTimeSpan} values={TimeSpans} onChange={(value) => onChangeSelectedTimeSpan(Number(value))} />
          <S.Charts>
            <Chart variant="new" timeSpanInDays={selectedTimeSpan} customers={customers} onChartLoadCallback={onNewCustomersAdoptionsChartLoaded} />
            <Chart variant="existing" timeSpanInDays={selectedTimeSpan} customers={customers} onChartLoadCallback={onExistingCustomersAdoptionsChartLoaded} />
          </S.Charts>
          <Legend legendNames={newCustomersAdoptionsLegendNames.concat(existingCustomersAdoptionsLegendNames)} />
        </S.Container>)
      }
    </Card>
  )
}

export default CustomerAdoptionCard

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
  `,
  Charts: styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-column-gap: 2px;
    width: 100%;
    margin-top: 5px;
  `
}
